import { createRouterMiddleware } from '@lagunovsky/redux-react-router'
import createSagaMiddleware from 'redux-saga'

import { browserHistory } from '../../config/router/history'
import { AVAILABLE_LOGOUT_REQUESTED } from '../modules/login/actions'
import { clearStoredAuthSession, logoutCurrentSession } from '../../utils/authSession'

const localStorageMiddleware = store => next => action => {
    if(action.type === AVAILABLE_LOGOUT_REQUESTED) {
        logoutCurrentSession()
            .catch(() => undefined)
            .finally(() => {
                clearStoredAuthSession()
            })
    }
    store.getState()
    next(action)
    store.getState()
}

export const sagaMiddleware = createSagaMiddleware()

const rootMiddleware = [
    createRouterMiddleware(browserHistory),
    sagaMiddleware,
    localStorageMiddleware
]

export default rootMiddleware
